import ApiService from "../api";

export default class SolicitacaoService extends ApiService {

    constructor() {
        super('/api/solicitacoes')
    }

    listarSolicitacoes(tipoProcesso, status, dataInicial, dataFinal) {
        var params = "?"
        if (tipoProcesso) {
            params += `tipoProcesso=${tipoProcesso}`
        }
        if (status) {
            params += `${params.length > 1 ? '&' : ''}status=${status}`
        }
        if (dataInicial) {
            params += `${params.length > 1 ? '&' : ''}dataInicial=${dataInicial}`
        }
        if (dataFinal) {
            params += `${params.length > 1 ? '&' : ''}dataFinal=${dataFinal}`
        }
        return this.get(params.length > 1 ? params : ``)
    }

    listarPendentes() {
        return this.get(`/pendentes`)
    }

    listarMinhasSolicitacoes() {
        return this.get(`/minhas-solicitacoes`)
    }

    buscarSolicitacao(id) {
        return this.get(`/${id}`)
    }

    executarAcao(id, dados) {
        return this.post(`/${id}/acoes`, dados)
    }

    assumirTarefa(id) {
        return this.post(`/${id}/assumir`, {})
    }

    transferirTarefa(id, dados) {
        return this.post(`/${id}/transferir`, dados)
    }

    cancelar(id, motivo) {
        return this.post(`/${id}/cancelar`, { motivo })
    }

    buscarTimeline(id) {
        return this.get(`/${id}/timeline`)
    }

    buscarExecutoresDeAtividades(id) {
        return this.get(`/${id}/executores`)
    }

    comentar(id, dados) {
        return this.post(`/${id}/comentarios`, dados)
    }

    listarProcessos() {
        return this.get(`/processos`)
    }

    previewEncaminhamentoAcao(id, acao) {
        return this.get(`/${id}/encaminhamento?acao=${acao}`)
    }

    previewEncaminhamentoCriacao(tipoProcesso, etapaCodigo, contexto = {}) {
        const params = new URLSearchParams();
        Object.entries(contexto).forEach(([chave, valor]) => {
            if (valor !== null && valor !== undefined && valor !== "") params.append(chave, valor);
        });
        return this.get(`/processos/${tipoProcesso}/etapas/${etapaCodigo}/encaminhamento?${params}`)
    }
}
